import Vue from 'vue';
import eventBus, {
  ON_CONFIRM_DIALOG_OPEN,
  ON_CONFIRM_DIALOG_OK_CLICK,
  ON_CONFIRM_DIALOG_CANCEL_CLICK,
} from '../../core/services/event-bus';

const ConfirmModal = {
  install(Vue) {
    Vue.prototype.$confirm = (
      title,
      message,
      successMessage = null,
      handler = null,
      handlerParams = null,
      additionalButtons = [],
    ) => {
      return new Promise((resolve) => {
        eventBus.$emit(ON_CONFIRM_DIALOG_OPEN, {
          message,
          successMessage,
          handler,
          handlerParams,
          title,
          additionalButtons,
        });
        eventBus.$off(ON_CONFIRM_DIALOG_OK_CLICK);
        eventBus.$on(ON_CONFIRM_DIALOG_OK_CLICK, (payload) => {
          resolve(payload);
        });
        eventBus.$on(ON_CONFIRM_DIALOG_CANCEL_CLICK, () => {
          resolve(false);
        });
      });
    };
  },
};

Vue.use(ConfirmModal);
